import React from 'react'
import PropTypes from 'prop-types'
// import { _ } from '@iskytrip/sdk'
import CSS from './index.module.css'
import BaseComponent from '@base/BaseComponent'
import { IconCodeEmum, Iconfont } from '@src/components'
import { Modal } from 'antd-mobile'

// 弹框-使用规则等
class GLModalRules extends BaseComponent {
	static propTypes = {
		isShow: PropTypes.bool,
		title: PropTypes.string,
		contents: PropTypes.array,
		close: PropTypes.func,
	}

	static defaultProps = {
		isShow: false,
		title: '提示',
		contents: [], // [{label: '使用规则', value: '具体内容'}]
		close: () => {},
	}

	constructor(props) {
		super(props)
		this.state = {
			buttonIndex: 0,
		}
	}

	selectBtn(index) {
		this.setState({
			buttonIndex: index,
		})
	}

	render() {
		let { isShow, title, contents, close } = this.props
		let { buttonIndex } = this.state
		let content = contents[buttonIndex] || {}

		return (
			<Modal
				popup
				visible={isShow}
				className={CSS.modal}
				animationType='slide-up'
				onClose={close.bind(this)}
			>
				<div className={CSS.iskytripContainer}>
					<div className={CSS.modalTitle}>
						<p>{title}</p>
						<Iconfont
							font={IconCodeEmum.CLOSE}
							style={{
								fontSize: '.32rem',
								color: '#D8D8D8',
								display: 'inline-block',
								lineHeight: '.4rem',
							}}
							onPress={close.bind(this)}
							f
						/>
					</div>
					<div className={CSS.modalBtn}>
						{contents.map((item, index) => {
							return (
								<div
									className={CSS.modalBtnItem}
									key={index}
									onClick={this.selectBtn.bind(this, index)}
								>
									<p
										className={
											buttonIndex === index ? CSS.modalBtnSelectLabel : ''
										}
									>
										{item.descKey || ''}
									</p>
									<div
										className={
											buttonIndex === index ? CSS.modalBtnSelectIndex : ''
										}
									></div>
								</div>
							)
						})}
					</div>
					<div className={CSS.modalContent}>{content.descValue || ''}</div>
				</div>
			</Modal>
		)
	}
}

export default GLModalRules
